import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringSwitchService {

  constructor() { }

  public switchString(value: string): string {
    switch (value) {
      case 'status':
        return 'Status';
      case 'pais':
        return 'Country';
      case 'crm':
        return 'CRM';
      case 'endereco':
        return 'Endereco';
      case 'especialidademedico':
        return 'Especialida do(a) médico(a)';
      case 'nomemedico':
        return 'Nome do(a) médico(a)';
      case 'posologia1':
        return 'Posologia 1';
      case 'posologia2':
        return 'Posologia 2';
      case 'posologia3':
        return 'Posologia 3';
      case 'posologia4':
        return 'Posologia 4';
      case 'produto1':
        return 'Produto 1';
      case 'produto2':
        return 'Produto 2';
      case 'produto3':
        return 'Produto 3';
      case 'produto4':
        return 'Produto 4';
      case "E":
        return "Erro";
      case "R":
        return "Revisado";
      case "P":
        return "Pendente validação";
      case "I":
        return "Integrado com a captura eletrônica";
      case "W":
        return "Aguardando revisão";
      case "codigoPostal":
        return "Codigo Postal";
      case "nomeInstituicao":
        return "Nombre de Institución";
      case "numeroEndereco":
        return "Número";
      case "rua":
        return "Camino";
      case "telefone":
        return "Teléfono";
      case "especialidade":
        return "Especialidad";
      case "localidade":
        return "Localidade";
      case "matricula":
        return "Matricula";
      case "dataReceita":
        return "Fecha de la receta";
      case "nome":
        return "Nombre";
      default:
        return value;
    }
  }
}
